<!-- 系统简介页 -->
<template>
    <div class="v-introduce">
        <div class="introduce-header">
            <v-header :isShowSearch="IsShowSearch"></v-header>
        </div>
        <!-- <div class="v-notice">
      《中华人民共和国基本医疗卫生与健康促进法》即将生效，权责2019修订)即将生效，权责事项共16项；中华人民共和国外资企业法(2016修正)已经失效，涉及权责事项25项；
    </div> -->
        <div class="introduce-content">
            <div class="v-notice">
                <Carousel v-model="CarouselValue" loop :autoplay="CarouselSetting.autoplay"
                    :autoplay-speed="CarouselSetting.autoplaySpeed" :dots="CarouselSetting.dots"
                    :radius-dot="CarouselSetting.radiusDot" :trigger="CarouselSetting.trigger"
                    :arrow="CarouselSetting.arrow">
                    <CarouselItem>
                        <span style="color: #f92841;">《中华人民共和国基本医疗卫生与健康促进法》2020年6月1日开始实施，包括权责事项13项。</span>
                    </CarouselItem>
                    <CarouselItem>
                        <span style="color: #f92841;">《中华人民共和国档案法》(2020修订)将于2021年1月1日开始实施，涉及权责事项13项。</span>
                    </CarouselItem>
                    <CarouselItem>
                        <span style="color: #3a97c8;">中华人民共和国中外合作经营企业法(2017修正)已经失效，涉及职权事项5项。</span>
                    </CarouselItem>
                </Carousel>
            </div>
            <div class="introduce-bg">
                推行权责清单制度是国家治理体系和治理能力现代化建设的重要举措,能够辅助形成边界清晰、分工合理、权责-致、运转高效、依法保障的政府职能体系。
                北大法宝权责清单智能管理系统以法律、法规和规章为依据,辅助各行政单位智能梳理权责清单,并对其进行动态更新管理,辅助司法局对权责清单进行智能审核。
            </div>
            <div class="introduce-panel">
                <div class="introduce-panel-title">
                    <span class="panel-title-zhcn">权责清单数据类功能</span>
                    <span class="panel-title-en">/Data function of responsibility list of the administrative power and
                        responsibility list</span>
                </div>
                <div class="introduce-panel-item" v-for="item in introduceListData" :key="item.id">
                    <div class="introduce-item-title">{{ item.title }}</div>
                    <div class="introduce-item-describe">{{ item.describe }}</div>
                    <div class="introduce-item-img">
                        <img :src="item.src" :alt="item.title">
                    </div>
                </div>
            </div>
            <div class="introduce-panel">
                <div class="introduce-panel-title">
                    <span class="panel-title-zhcn">权责清单应用类功能</span>
                    <span class="panel-title-en">/Application functions of responsibility list of the administrative
                        power and
                        responsibility list</span>
                </div>
                <div class="introduce-panel-item" v-for="item in introduceAppData" :key="item.id">
                    <div class="introduce-item-title">
                        <i :class="item.icon"></i>
                        {{ item.title }}
                    </div>
                    <div class="introduce-item-describe describe-padding">{{ item.describe }}</div>
                </div>
            </div>
        </div>
        <BackTop :height="backTopHei" :duration="backTopDur" class="btn-backtop">
            <div class="btn-backtop-icon"></div>
        </BackTop>
        <div class="accrual-footer">
            <div class="accraul-introduce">
                <a href="javascript:void(0);">北大法宝权责清单智能管理系统简介</a>
            </div>
            <div class="accrual-copyright">
                <div class="copyright-item">
                    <a href="https://pkulaw.com/helps/58.html" target="_blank">英华介绍</a>
                    <span>::</span>
                    <a href="http://www.pkulaw.cn/help/index.html?item=FBKH" target="_blank">经典客户</a>

                    <span>::</span>
                    <a href="https://pkulaw.com/help/more-service-law-notice.html" target="_blank">法律声明</a>
                    <span>::</span>
                    <a href="http://www.pkulaw.cn/css/websit_map.htm" target="_blank">网站地图</a>
                    <span>::</span>

                    <a href="mailto:info@chinalawinfo.com">企业邮箱</a>
                </div>
                <p>版权所有 ：北京北大英华科技有限公司 北京大学法制信息中心 <a href="http://www.beian.miit.gov.cn/"
                        target="_blank">京ICP证010230-17号</a></p>
                <div class="copyright-logo">
                    <a href="http://www.pkulaw.cn/help/ad/20140818/index.html" rel="nofollow" target="_blank">
                        <img src="https://pkulaw.com/content/images/bdfb.jpg" alt="">
                    </a>
                    <a href="https://ss.knet.cn/verifyseal.dll?sn=e13042211010040250ewgy000000&amp;ct=df&amp;a=1&amp;pa=0.3386153630929789"
                        rel="nofollow" target="_blank"></a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import VHeader from '@/views/header/VHeader.vue'
    export default {
        name: 'vIntroduce',
        components: {
            VHeader
        },
        props: {
            // 小驼峰命名
            demoInfo: {
                type: String,
                default() {
                    return 'introduce-demo'
                }
            }
        },
        data() {
            return {
                // 是否显示搜索框,1显示，2只有背景，3隐藏
                IsShowSearch: '2',
                introduceListData: [
                    {
                        id: '1',
                        title: '(一)权责事项法规依据版本自动升级',
                        describe: '法律法规随着社会的进步而不断修改，权责事项的法规依据版本也需要随之更新。通过本系统的权责事项法规依据版本智能核检，可以快速识别出这些事项最新的法规依据。',
                        src: require('../../assets/introduce1.jpg')
                    },
                    {
                        id: '2',
                        title: "(二)权责事项失效法规依据自动删除",
                        describe: "随着法律法规的时效性变动，有些权责事项的法规已经失效，应该将这些失效的法规依据从权责清单中删除。通过本系统的权责事项时效性核检，可以快速识别出这些失效的事项。",
                        src: require('../../assets/introduce2.jpg')
                    },
                    {
                        id: '3',
                        title: "(三)权责事项法规依据补充",
                        describe: "很多权责事项有多个法规依据，各单位在整理法规依据时，很难全面找到。通过本系统的权责事项法规依据智能核检，可以快速找出权责事项缺失的法规依据。",
                        src: require('../../assets/introduce3.jpg')
                    },
                    {
                        id: '4',
                        title: "(四)权责事项智能核检补充",
                        describe: "各行政单位在梳理权责清单的时候，难免漏掉一些权责事项，造成权责清单不够全面、准确。然而人工核验工作量非常大，且难以全面，通过本系统的权责事项智能核检，可以有效地查出缺失权责事项，并作相应的更补。",
                        src: require('../../assets/introduce4.jpg')
                    },
                    {
                        id: '5',
                        title: "(五)失效权责事项智能提醒",
                        describe: "随着法律法规的时效性变动，有些法规已经失效，这些法规所涉及的权责事项也会随之失效。这些权责事项便应该从权责清单中删除。通过本系统的权责事项时效性智能核检，可以快速识别出这些失效的事项。",
                        src: require('../../assets/introduce5.jpg')
                    }
                ],
                introduceAppData: [
                    {
                        id: '1',
                        title: '履职评估',
                        describe: '在权力事项清单基础上,结合行政执法文书等数据,可以评估出各单位的权力使用情况,生成履职评估报告。',
                        icon: 'introduce-icon-title1'
                    },
                    {
                        id: '2',
                        title: "职位风险预警",
                        describe: "在责任事项清单基础上,将各职位的责任按照法律后果严重程度划出等级,可以评估出每个职位的风险指数,根据事件评估出风险,及时预警。",
                        icon: 'introduce-icon-title2'
                    }
                ],
                // 轮播图选中页
                CarouselValue: 0,
                // 轮播图参数配置
                CarouselSetting: {
                    autoplay: true,
                    autoplaySpeed: 6000,
                    dots: 'none',
                    radiusDot: true,
                    trigger: 'click',
                    arrow: 'never'
                },
                // 返回顶部临界值
                backTopHei: 10,
                // 返回顶部动画时长
                backTopDur: 600,
            }
        },
        computed: {

        },
        watch: {

        },
        created() {

        },
        mounted() {

        },
        destoryed() {

        },
        methods: {
            // 请求方法 动词开头 + 自定义 + data结尾
            getAxiosData() {

            },

            // 其他方法 动词开头 + 自定义
            setLocalStorage() {

            }
        }
    }
</script>

<style scoped>
    .v-introduce {
        overflow: hidden;
        background-color: #f7f8f8;
    }

    .v-notice {
        margin: 20px 0;
        /* padding: 0 20px; */
        /* width: 1500px; */
        font-size: 16px;
        color: #f92841;
    }

    .introduce-header {
        background-color: #fff;
    }

    .introduce-content {
        overflow: hidden;
        margin: 0 auto;
        /* margin-bottom: 70px; */
        padding: 0 70px 20px;
        width: 1200px;
        background-color: #fff;
    }

    .introduce-bg {
        margin: 30px 0;
        padding: 38px 26px;
        font-size: 18px;
        text-indent: 2em;
        color: #013f58;
        background-color: #e5f6fd;
    }

    .introduce-panel-title {
        margin-bottom: 20px;
    }

    .panel-title-zhcn {
        font-size: 22px;
        font-family: 'Microsoft Yahei', Arial, Helvetica, sans-serif;
        color: #1867dd;
    }

    .panel-title-en {
        font-size: 16px;
        color: #bac3c8;
    }

    .panel-title-zhcn::before {
        content: "";
        display: inline-block;
        margin-right: 12px;
        border-radius: 2px;
        width: 5px;
        height: 20px;
        background-color: #1867dd;
    }

    .introduce-item-title {
        margin-bottom: 6px;
        font-family: 'Microsoft Yahei', Arial, Helvetica, sans-serif;
        font-size: 20px;
        font-weight: bold;
        color: #333333;
    }

    .introduce-item-describe {
        margin-bottom: 4px;
        font-family: 'Microsoft Yahei', Arial, Helvetica, sans-serif;
        font-size: 18px;
        text-indent: 2em;
        color: #333333;
    }

    .introduce-item-img img {
        width: 100%;
    }

    .describe-padding {
        margin-bottom: 20px;
    }

    .introduce-icon-title1 {
        display: inline-block;
        width: 20px;
        height: 20px;
        background: url(../../assets/introduce-icon1.png) 0 0 no-repeat;
    }

    .introduce-icon-title2 {
        display: inline-block;
        width: 20px;
        height: 20px;
        background: url(../../assets/introduce-icon1.png) 0 0 no-repeat;
    }

    .introduce-panel-item {
        margin-bottom: 20px;
    }

    .accrual-footer {
        padding: 0 20px;
        color: #fff;
        background-color: #17181e;
    }

    .accraul-introduce {
        padding: 20px;
        text-align: center;
        border-bottom: 1px solid #394c5e;
        /* background-color: #17181e; */
    }

    .accraul-introduce a {
        font-size: 24px;
        color: #fff;
    }

    .accrual-copyright {
        position: relative;
        padding: 20px;
        text-align: center;
        /* background-color: #17181e; */
    }

    .accrual-copyright a {
        color: #fff;
    }

    .copyright-item {
        margin-bottom: 10px;
    }

    .copyright-logo {
        position: absolute;
        top: 24px;
        right: 60px;
    }

    .btn-backtop-icon {
        width: 44px;
        height: 48px;
        background: url(../../assets/backtop.png) 0 0 no-repeat;
    }
</style>